import { render, staticRenderFns } from "./messageDetail.vue?vue&type=template&id=7e498465&scoped=true"
import script from "./messageDetail.vue?vue&type=script&lang=js"
export * from "./messageDetail.vue?vue&type=script&lang=js"
import style0 from "./messageDetail.vue?vue&type=style&index=0&id=7e498465&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e498465",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e498465')) {
      api.createRecord('7e498465', component.options)
    } else {
      api.reload('7e498465', component.options)
    }
    module.hot.accept("./messageDetail.vue?vue&type=template&id=7e498465&scoped=true", function () {
      api.rerender('7e498465', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Problem/complaintWorkOrder/messageDetail.vue"
export default component.exports